export default __webpack_public_path__ + "images/ad9d4dd2a8744e99c4dafc9406421691.png";